<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!-- 상세 영역 -->
      <family-event-list-comp @returnSearchCallback="listSearchCallback" @returnQueryResult="callbackQuery" @returnPagingResult="callbackPaging" @returnResult="onClickEventList" ref="eventListSearch">
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="space-between">
              <md-button class="md-info md-sm" @click="clearEventInfo(); isShowBasicInfo = true">
                <md-icon>event_available</md-icon>
                신규 행사
              </md-button>
          </md-card-actions>
        </div>
      </family-event-list-comp>

      <!-- 행사 기본 정보 -->
      <md-card v-if="this.isShowBasicInfo">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>행사 기본 정보
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <colgroup>
              <col width="17%">
              <col width="33%">
              <col width="17%">
              <col width="33%">
            </colgroup>
            <tr>
              <th>교우선택</th>
              <td>
                <div class="inline-flex">
                  <input type="text" maxlength="8" v-model="eventInfo.prizeMem"/>&nbsp;
                  <input type="text" maxlength="8" v-model="eventInfo.prizeNo"/>
                  <button @click=" () => { this.isShowMemberModal = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>경조코드</th>
              <td>
                <div class="inline-flex">
                  <select v-model="eventInfo.kyjoCd" name="kyjoCd">
                    <option v-for="item in kyjoCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                  <input type="text" :disabled="eventInfo.kyjoCd != '03'" v-model="eventInfo.prizeEtc">
                </div>
              </td>
            </tr>
            <tr>
<!--          <th>포상코드</th>
              <td>
                <select v-model="eventInfo.prizeCd" name="prizeCd" :disabled="eventInfo.seqNo && eventInfo.seqNo!=''">
                  <option v-for="item in prizeCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                    {{ item }}
                  </option>
                </select>
              </td>
-->
            </tr>
            <tr>
              <th>접수내용</th>
              <td>
                <input type="text" v-model="eventInfo.remark" maxlength="200">
              </td>
              <th>장소</th>
              <td>
                <input type="text" v-model="eventInfo.place" maxlength="20">
              </td>
            </tr>
            <tr>
              <th>행사일시</th>
              <td>
                  <input type="text" v-model="eventInfo.useDate" v-mask="'####-##-##'" class="w80">
                  <input type="text" v-model="eventInfo.useTime" placeholder="시간입력" class="txt-date-time w110">
              </td>
              <th>조치</th>
              <td>
                <div class="inline-flex">
                  <select v-model="eventInfo.actCd" name="actCd">
                    <option v-for="item in actCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                  <input type="text" :disabled="eventInfo.actCd != '07'" v-model="eventInfo.actEtc">
                </div>
              </td>
            </tr>
            <tr>
              <th>리본내용</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventInfo.ribbonCont" maxlength="50">
                </div>
              </td>
              <th>발송명의</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventInfo.fromNm" maxlength="8">
                </div>
              </td>
            </tr>
            <tr>
              <th>의뢰</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventInfo.request" maxlength="10">
                </div>
              </td>
              <th>주문일자</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventInfo.orderDate" v-mask="'####-##-##'">
                </div>
              </td>
            </tr>
            <tr>
              <th>업체</th>
              <td>
                <div class="inline-flex">
                  <select v-model="eventInfo.storeCd" name="actCd">
                    <option v-for="item in storeCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </td>
              <th>금액</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventInfo.amt" placeholder="금액을 입력하세요" maxlength="11">
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="saveEvent()">
            <md-icon>check</md-icon>
            {{eventInfo.seqNo && eventInfo.seqNo!='' ? '수 정' : '저 장'}}
          </md-button>
          <md-button class="md-default md-sm" @click="clearEventInfo(); isShowBasicInfo = false" v-if="!eventInfo.seqNo || eventInfo.seqNo==''">
            <md-icon>clear</md-icon>취 소
          </md-button>
          <md-button class="md-default md-sm" @click="deleteEvent" v-if="eventInfo.seqNo && eventInfo.seqNo!=''">
            <md-icon>clear</md-icon>삭 제
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div>
      <!--교우검색 팝업 -->
      <member-search-pop-comp :is-show.sync="isShowMemberModal" @returnResult="onSelectedModalMember"></member-search-pop-comp>
    </div>

    <!--경조사 관리 (통계) -->
    <family-event-statistics-comp></family-event-statistics-comp>
    <div id="scrollTargetBox"></div>
  </div>
</template>

<script>

import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";

import familyEventListComp from "@/pages/KuaaEvent/Components/familyEventListComp"
import familyEventStatisticsComp from "@/pages/KuaaEvent/Components/familyEventStatisticsComp"

import { MemberSearchPopComp } from "@/pages"

export default {

  components: {
    familyEventListComp,
    MemberSearchPopComp,
    familyEventStatisticsComp
  },

  created() {
    this.getKyjoCdList();
    this.getPrizeCdList();
    this.getActCdList();
    this.getStoreCdList();
  },

  computed: {
  },

  data(){
    return {
      isShowMemberModal : false,
      isShowBasicInfo : false,
      prizeMemNm : '',
      pagination: null,
      query: null,
      eventInfo : {
        prizeMem : null,
        kyjoCd : null, //경조코드
        prizeEtc : '', //경조 - 기타
        prizeCd : null, //포상코드
        remark : '', //접수내용
        place : '', //장소
        useDate : '', //행사일시
        useTime : '', //행사시간
        actCd : '', //조치
        actEtc : '', //조치-기타
        ribbonCont : '', //리본내용
        fromNm : '',//빌송명의
        request : '', //의뢰
        orderDate : moment().format('YYYY-MM-DD'),//주문일자
        storeCd : null,//업체
        amt : ''//금액
      },
      kyjoCdList : [], // 경조 코드 리스트
      prizeCdList : [], // 포상코드 리스트
      actCdList : [], // 조치 리스트
      storeCdList : [], // 업체 리스트
    }
  },

  methods : {
    clearEventInfo () {
      this.prizeMemNm = '';
      this.eventInfo = {
        prizeMem : null,
        kyjoCd : null, //경조코드
        prizeEtc : '', //경조 - 기타
        prizeCd : null, //포상코드
        remark : '', //접수내용
        place : '', //장소
        useDate : null, //행사일시
        useTime : '', //행사시간
        actCd : '', //조치
        actEtc : '', //조치-기타
        ribbonCont : '', //리본내용
        fromNm : '',//발송명의
        request : '', //의뢰
        orderDate : moment().format('YYYY-MM-DD'),//주문일자
        storeCd : null,//업체
        amt : ''//금액
      }
    },
    getKyjoCdList () {
      kuaaFnc.fnckyjoCodes(null,res => {
        this.kyjoCdList = res.data.data.contents;
      });
    },
    getPrizeCdList () {
      kuaaFnc.fncPrizeCodes(null,res => {
        this.prizeCdList = res.data.data.contents;
      });
    },
    getActCdList () {
      kuaaFnc.fncActCodes(null,res => {
        this.actCdList = res.data.data.contents;
      });
    },
    getStoreCdList () {
      kuaaFnc.fncStoreCodes(null,res => {
        this.storeCdList = res.data.data.contents;
      });
    },
    onSelectedModalMember (item){
      this.eventInfo.prizeMem = item.memberHnm;
      this.eventInfo.prizeNo = item.memberNo;
    },
    onClickEventList (item){
      item = JSON.parse(JSON.stringify(item))
      item['useDate'] = this.parseFormatter(item['useDate']);
      item['orderDate'] = this.parseFormatter(item['orderDate']);
      this.eventInfo = item;
      this.eventInfo.prizeMem = item.memberHnm;
      this.eventInfo.prizeNo = item.memberNo;
      this.eventInfo.amt = !item.amt ? '' : formatter.getCurrency(item.amt);
      this.isShowBasicInfo = true;
      kuaaFnc.scrollTo('scrollTargetBox');
    },
    listSearchCallback(){
      this.clearEventInfo();
      this.isShowBasicInfo = false;
    },
    addEvent (){

      if(!this.eventInfo.useDate || this.eventInfo.useDate==''){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'행사일시를 입력 해 주세요'}));
        return;
      }

	  if(this.eventInfo.kyjoCd != "03"){
	  	if(!this.eventInfo.prizeMem || this.eventInfo.prizeMem==''){
	        Swal.fire(kuaaFnc.getSwalModaloptions({html:'교우를 선택해 주세요'}));
	        return;
     	 }
	  }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "행사를 추가 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          let params = JSON.parse(JSON.stringify(this.eventInfo));
          params['prizeCd'] = '09';
          params['useDate'] = this.customFormatter(params['useDate']);
          params['orderDate'] = this.customFormatter(params['orderDate']);

          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_PRIZE,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `추가 되었습니다.`;
                Swal.fire(modalOptions);
                this.getEventList();
              } else {
                modalOptions.html = `추가 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },
    getEventList(){
      this.$refs.eventListSearch.sendQuery();
    },
    updateEvent(){

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "행사를 수정 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          let params = JSON.parse(JSON.stringify(this.eventInfo));
//          params['prizeCd'] = '09';
          params['useDate'] = this.customFormatter(params['useDate']);
          params['orderDate'] = this.customFormatter(params['orderDate']);
          params['amt'] = params['amt'].replaceAll(",","").trim();

          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.UPDATE_PRIZE,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `수정 되었습니다.`;
                Swal.fire(modalOptions);
                this.getEventList();
              } else {
                modalOptions.html = `수정 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },
    saveEvent(){
      if(this.eventInfo.seqNo){ // 수정일 경우
        this.updateEvent();
      }else{
        this.addEvent();
      }
    },
    deleteEvent(){

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "행사를 삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          let params = {
            seqNo : this.eventInfo.seqNo,
            useDate : this.customFormatter(this.eventInfo.useDate),
            prizeCd : '09',
          };

          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_PRIZE,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `수정 되었습니다.`;
                Swal.fire(modalOptions);
                this.getEventList();
              } else {
                modalOptions.html = `수정 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },
    parseFormatter(date){
      let res = date && date != '' ? moment(date).format("YYYY-MM-DD") : '';
      return res;
    },
    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },
    
    callbackQuery(result){
      this.query = result;
    },
    callbackPaging(result){
      this.pagination = result;
    }
  }
}
</script>

<style scoped>
  .txt-date-time {vertical-align: middle; margin-top: 15px; margin-bottom: 15px;}
</style>